import { Box } from "@chakra-ui/react";
import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import AkruCreditUnions from "./components/AkruCreditUnions";

const AkruCreditUnionsPage = () => {
    return (
        <Box>
            <Header />
            <AkruCreditUnions />
            <Footer />
        </Box>
    );
};

export default AkruCreditUnionsPage;
